"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.RecordProximityNode = void 0;
const BaseNode_1 = require("../../BaseNode");
const LookupHelper_1 = require("../LookupHelper");
const Schema = __importStar(require("./schema.json"));
const lodash_1 = require("lodash");
const NODE_TYPE = 'RECORD-PROXIMITY';
const MAX_UNDEFINED_RESULTS = 10000; //Picked a random large number as the limit if a max was not specified
/**
 * Return records of various types based on a given location and proximity.
 */
class RecordProximityNode extends BaseNode_1.BaseNode {
    constructor() {
        super(...arguments);
        this.asynchronousResolver = async (nodeMap) => {
            var _a, _b, _c, _d;
            const result = {
                exists: false,
                successfulLookup: false,
                results: [],
            };
            const { distanceUnit, strategy, maxResults } = Object.assign({ distanceUnit: this._interfaceDefinition.definitions.ConfigParams.properties.distanceUnit.default, strategy: this._interfaceDefinition.definitions.ConfigParams.properties.strategy.default, maxResults: MAX_UNDEFINED_RESULTS }, this.config);
            if ((0, LookupHelper_1.hasStrategyPreReqs)(strategy, (_a = this.accessorMap) === null || _a === void 0 ? void 0 : _a.ONLINE_PROXIMITY_LOOKUP, (_b = this.accessorMap) === null || _b === void 0 ? void 0 : _b.OFFLINE_PROXIMITY_LOOKUP)) {
                const { aggregateTypes, centerLatitude, centerLongitude, proximityDistance } = await this.asynchronousResolveInputs(nodeMap);
                if (centerLatitude && centerLongitude && proximityDistance) {
                    const results = await (0, LookupHelper_1.lookupProximity)((_c = this.accessorMap) === null || _c === void 0 ? void 0 : _c.ONLINE_PROXIMITY_LOOKUP, (_d = this.accessorMap) === null || _d === void 0 ? void 0 : _d.OFFLINE_PROXIMITY_LOOKUP, strategy, {
                        aggregateTypes,
                        centerLatitude,
                        centerLongitude,
                        proximityDistance,
                        distanceUnit,
                        limit: maxResults,
                    });
                    result.exists = results.results.length > 0;
                    result.successfulLookup = results.lookupSucceeded;
                    result.results = results.results;
                }
            }
            // Accessor was not available, can not run this transform
            return result;
        };
        this.synchronousResolver = (_nodeMap) => {
            throw new Error('Record Proximity is not allowed as a synchronously resolving node');
        };
        //TODO: Build the interface definition from the given schema....but what is our schema
        this._interfaceDefinition = Schema;
    }
    // we override the schema definition here so that we can provide it based on the selected value
    get interfaceDefinition() {
        //grab the available record types if available
        const aggregateTypes = this.schemaLookup.getAggregates && this.schemaLookup.getAggregates();
        // Override params schemas
        const inputParams = Object.assign({}, this._interfaceDefinition.definitions.InputParams);
        (0, lodash_1.set)(inputParams, 'properties.aggregateTypes.items.enum', aggregateTypes);
        return Object.assign(Object.assign({}, Schema), { InputParams: inputParams, OutputParams: this._interfaceDefinition.definitions.OutputParams, ConfigParams: this._interfaceDefinition.definitions.ConfigParams });
    }
}
exports.RecordProximityNode = RecordProximityNode;
RecordProximityNode._nodeDefinition = {
    NODE_TYPE,
    defaultTitle: 'Records within Proximity',
    isIdempotent: false,
    primaryCategory: 'Data Lookup',
};
//# sourceMappingURL=RecordProximity.js.map